<template>
    <Cascader :id="filterType==='roomType'?'cascder':''" :data="choices" v-model="selectValue" :placeholder="placeholder"
              :change-on-select="changeOnSelect" :render-format="format" :trigger="trigger" :clearable="selectValue!=0?true:false">
    </Cascader>
</template>
<style>
    .filter-header .ivu-cascader input {
        border: 0 none;
        padding: 0;
        font-size: 14px;
        padding-left: 12px;
    }

    .filter-header .ivu-cascader-visible input,
    .filter-header .ivu-cascader input:focus {
        box-shadow: none;
        border: 1px solid #353838;
    }

    .filter-header .ivu-cascader .ivu-cascader-arrow {
        right: 12px;
        color: #353838;
    }

    .filter-header .ivu-cascader .ivu-select-dropdown {
        overflow: visible;
    }

    .filter-header .ivu-cascader .ivu-cascader-menu-item-focus,
    .filter-header .ivu-cascader .ivu-cascader-menu-item:hover {
        background: #F2F4F5;
    }

    .filter-header .ivu-cascader .ivu-input-wrapper input::-webkit-input-placeholder {
        color: #353838;
    }

    .filter-header .ivu-cascader .ivu-input-wrapper input:-moz-placeholder {
        color: #353838;
    }

    .filter-header .ivu-cascader .ivu-input-wrapper input::-moz-placeholder {
        color: #353838;
    }

    .filter-header .ivu-cascader .ivu-input-wrapper input:-ms-input-placeholder {
        color: #353838;
    }

    .filter-header .ivu-cascader-menu .ivu-cascader-menu-item-active {
        color: inherit;
    }

    #cascder .ivu-select-dropdown {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 400px;
    }

    .filter-header .ivu-cascader .ivu-select-dropdown

    .filter-header .ivu-cascader .ivu-select-dropdown span ul {
        height: auto;
    }

    .filter-header .ivu-cascader .ivu-select-dropdown span span {
        display: block;
        position: absolute;
        right: -100%;
        top: 0;
        width: 100%;
        height: 100%;
    }

    .filter-header .ivu-cascader .ivu-select-dropdown .ivu-cascader-menu {
        text-align: left;
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
    }
</style>
<script>
    export default {
        props: {
            choices: {
                type: Array,
                required: true
            },
            selected: {
                required: true
            },
            changeOnSelect: {
                type: Boolean,
                default: false
            },
            format: {
                type: Function,
                default(labels){
                    return labels[labels.length - 1]
                }
            },
            trigger: {
                type: String,
                default: 'click'
            },
            placeholder: {
                type: String,
            },
            filterType: {
                type: String
            }
        },
        data(){
            return {
                selectValue: this.initSelectValue()
            }
        },
        watch: {
            selectValue: {
                handler: function (val) {
                    this.$emit('selectChange', this.filterType, val.join(','));
                },
                deep: true
            },

        },
        methods: {
            initSelectValue(){
                return !this.selected ? [0] : this.selected.split(',').map(function (id) {
                    return Number(id);
                });
            },
        },
    }
</script>